var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimes = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20.965 20.965"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m14.456 10.482 5.96-5.96a1.874 1.874 0 0 0 0-2.649L19.091.548a1.874 1.874 0 0 0-2.649 0l-5.96 5.96-5.96-5.96a1.874 1.874 0 0 0-2.649 0L.549 1.873a1.874 1.874 0 0 0 0 2.649l5.96 5.96-5.96 5.96a1.874 1.874 0 0 0 0 2.649l1.325 1.325a1.874 1.874 0 0 0 2.649 0l5.96-5.96 5.96 5.96a1.874 1.874 0 0 0 2.649 0l1.325-1.325a1.874 1.874 0 0 0 0-2.649Z"
})));
export default SvgTimes;